<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-12 18:06:52
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-10 12:23:56
 * @Description: file content
 -->
<template>
  <div>
    <!-- 内容自行动弹出框 -->
    <div class="mask" v-show="isShowSelfAction">
      <div class="popup-layer animated zoomIn">
        <div class="popup">
          <div class="top-layer">
            <div class="headImg">
              <img :src="spreadInfo.imageurl" alt />
              <span>{{spreadInfo.name}}</span>
            </div>
            <div class="title">{{selfInfo.word}}</div>
          </div>
          <div class="item-layer" v-for="item in selfInfo.items" @click="clickItem(item)">
            <div v-if="item.type==enumType.chat" class="btn"></div>
            <div v-else class="item">{{item.name}}</div>
          </div>
          <div style="width: 100%; height: .3rem"></div>
        </div>
        <div class="close" @click="showBall"></div>
      </div>
    </div>
    <!-- 浮悬球 -->
    <div class="fload-head" v-show="isShowBall" @click="showSelfAction">
      <img :src="spreadInfo.imageurl" alt />
    </div>
    <HdkShare v-if="isShowHdkShare" v-on:close="isShowHdkShare=false"></HdkShare>
    <ShareGuide v-show="isShowShareGuide" :myProp="spreadInfo" v-on:close="isShowShareGuide=false"></ShareGuide>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="showImg2.isShow=false"></ShowImg2>
  </div>
</template>
<script>
import request from "@/utils/request";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
import global_ from "@/global.config";
import { mapState, mapMutations } from "vuex";
const HdkShare = () => import("@/components/hdk-share.vue");
const ShareGuide = () => import("@/components/share_guide3");
const ShowImg2 = () => import("@/components/showimg2");

export default {
  components: {
    HdkShare,
    ShareGuide,
    ShowImg2
  },
  props: {
    // option: null,
    //   option: {
    //     // pageid: 1332,
    //     refereeopenid: 'oj3y9wLZmOiaSyrfyIQiPMmbUAHg',
    //     openid: 'oj3y9wGThdLqhn0bZWOj7DeO2Tww',
    //     passport: 'b4de197ab7b03e9d014116821e90d54f',
    //     apiurl: 'https://qmyx.quanc.com.cn/qc-webapp/wxapi.do',
    //     pageid: 8623,
    //     // openid: 'oj3y9wGThdLqhn0bZWOj7DeO2Tww',
    //     // refereeopenid: 'oj3y9wLZmOiaSyrfyIQiPMmbUAHg',
    //     // passport: 'b4de197ab7b03e9d014116821e90d54f',
    //     chaturl: 'https://zcmdm.quanc.com.cn/marketies/rc/rs-direction.html?type=chat&receiveropenid=o7aBL1Bk_9gwP7gfTfccIVPd-vkI&nickname=总裁面对面&ucallphone=13262256828',
    //     // apiurl: 'https://qmyx.ttrushi.com/qc-webapp/wxapi.do',
    //     // type: 1
    //   },
    options: {
      type: Object
    }
  },
  data() {
    return {
      //弹出自行动播放音乐
      promptSound: new Audio(
        "https://assets.rurushishi.com/sharelib/iPhone.mp3"
      ),
      //传播者信息
      spreadInfo: {
        currentname: "", //当前用户名字
        imageurl: "https://assets.wxmp.ruthus.com/henduoke/ai/new_head.png", //传播者头像 默认。会从接口里面拿。
        name: "小原", //传播者名字 默认
        type: 3 //类型 默认
      },
      // 自行动配置
      selfInfo: {
        word: "和别人分享你的知识，那才是永恒之道", //默认
        items: [
          // {
          //   type: "",
          //   name: "",
          //   param: {}
          // }
        ]
      },
      // 枚举按钮类型
      enumType: {
        share: "share", //分享
        subscribe: "subscribe", //关注
        draw: "draw", //抽奖
        chat: "chat", //聊天
        switchToMine: "switchToMine" //换成我的内容
      },
      isShowSelfAction: false, //是否显示内容自行动
      isShowBall: false, //是否显示浮球
      isShowHdkShare: false, //是否显示分享
      isShowShareGuide: false, //是否显示分享引导
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_CARDINFO: "SET_CARDINFO",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO"
    }),
    clickItem(item) {
      switch (item.type) {
        case this.enumType.share:
          this.clickShare(item);
          break;
        case this.enumType.subscribe:
          this.clickSubscribe(item);
          break;
        case this.enumType.chat:
          this.clickChat(item);
          break;
        case this.enumType.draw:
          this.clickDraw(item);
          break;
        case this.enumType.switchToMine:
          this.clickSwitchToMine(item);
          break;
        default:
          break;
      }
    },
    // 分享
    clickShare(item) {
      if (this.isInMiniProgram) {
        this.isShowHdkShare = true;
      } else {
        this.isShowShareGuide = true;
      }
    },
    // 关注
    clickSubscribe(item) {
      let that = this;
      if (this.isInMiniProgram) {
        //同转发文章到朋友圈还未关注公众号的情景
        if (item.param.type == "hdk") {
          // 很多客
          util.navigateToShareMomentsPageReturnImg(this, {
            // title: "关注很多客公众号，天天都有高净值精彩获客内容免费更新",
            // desc: "24位您的朋友已经关注了",
            // img:
            //   "https://assets.rurushishi.com/yq-rs-make/other/henduoke_icon.png",
            sendMessageTitle:
              "关注很多客公众号，天天都有高净值精彩获客内容免费更新",
            sendMessageImg:
              "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon5.png",
            // intro: "关注很多客公众号，天天都有高净值精彩获客内容免费更新"
            action: "qr_subscribe_gzh_hdk"
          });
        } else if (item.param.type == "hdb") {
          // 很多宝
          util.navigateToShareMomentsPageReturnImg(this, {
            // title: "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            // desc: "24位您的朋友已经关注了",
            // img:
            //   "https://assets.rurushishi.com/yq-rs-make/other/henduobao_icon.png",
            sendMessageTitle:
              "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            sendMessageImg:
              "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon6.png",
            // intro: "关注很多宝公众号，天天都有高净值精彩内容免费更新"
            action: "qr_subscribe_gzh_hdb"
          });
        }
      } else {
        if (item.param.type == "hdk") {
          // 很多客
          that.showImg2 = {
            isShow: true,
            url: item.param.url,
            width: "50%",
            intro: "扫码关注，免费获取AI获客神器！"
          };
        } else if (item.param.type == "hdb") {
          // 很多宝
          that.showImg2 = {
            isShow: true,
            url: item.param.url,
            width: "50%",
            intro: "扫码关注，为您汇聚高净值精彩内容！"
          };
        }
      }
    },
    // 抽奖
    clickDraw(item) {
      comreq.actAdv(this, this.$enumUserEvent.draw);
      util.openDraw(this, item.param.url);
    },
    // 咨询
    clickChat() {
      comreq.actAdv(this, this.$enumUserEvent.spreadChat);
      util.openChat(this);
    },
    // 换成我的
    clickSwitchToMine() {
      let that = this;
      util.switchToMine(this).then(data => {
        if (data == 4) {
          comreq
            .wxAcode(that, "pages/hdk/register/register")
            .then(function(data) {
              if (data) {
                that.showImg2 = {
                  isShow: true,
                  url: data,
                  width: "50%",
                  intro: "扫码，免费获取AI获客神器！"
                };
              } else {
                this.messageBox("获取小程序码失败！");
              }
            });
        }
      });
    },

    // 展示浮悬球
    showBall() {
      this.isShowSelfAction = false;
      this.isShowBall = true;
    },
    // 展示自行动配置
    showSelfAction() {
      this.isShowSelfAction = true;
      this.isShowBall = false;
    },
    // 处理配置信息
    createPageSelfConfigPop(pageSelfConfig) {
      let that = this;
      return new Promise(function(resolve, reject) {
        // 设置推荐语句
        if (pageSelfConfig.firstcontent) {
          that.selfInfo.word =
            that.spreadInfo.currentname + "，" + pageSelfConfig.firstcontent;
        } else {
          that.selfInfo.word =
            that.spreadInfo.currentname + "，" + that.selfInfo.word;
        }

        // 分享
        if (pageSelfConfig.share == 1 && pageSelfConfig.sharecontent) {
          that.selfInfo.items.push({
            type: that.enumType.share,
            name: pageSelfConfig.sharecontent,
            param: null
          });
        }
        // 关注 很多宝
        if (
          pageSelfConfig.subscribe == 1 &&
          pageSelfConfig.subscribecontent &&
          pageSelfConfig.subscribelink
        ) {
          that.selfInfo.items.push({
            type: that.enumType.subscribe,
            name: pageSelfConfig.subscribecontent,
            param: {
              type: "hdb",
              url:
                "https://assets.rurushishi.com/yq-rs-make/other/henduobao_code.jpg"
            }
          });
        }
        // 关注2 很多客
        if (
          pageSelfConfig.subscribe2 == 1 &&
          pageSelfConfig.subscribecontent2 &&
          pageSelfConfig.subscribelink2
        ) {
          that.selfInfo.items.push({
            type: that.enumType.subscribe,
            name: pageSelfConfig.subscribecontent2,
            param: {
              type: "hdk",
              url:
                "https://assets.rurushishi.com/yq-rs-make/other/henduoke_code.jpg"
            }
          });
        }
        // 抽奖
        if (pageSelfConfig.award == 1 && pageSelfConfig.awardcontent) {
          that.selfInfo.items.push({
            type: that.enumType.draw,
            name: pageSelfConfig.awardcontent,
            param: {
              url: pageSelfConfig.awardlink
            }
          });
        }

        // 切换成你自己的内容，传播获客
        if (pageSelfConfig.agentcontent) {
          that.selfInfo.items.push({
            type: that.enumType.switchToMine,
            name: pageSelfConfig.agentcontent,
            param: null
          });
        }

        // 聊天，默认就配置
        that.selfInfo.items.push({
          type: that.enumType.chat,
          name: undefined,
          param: null
        });
        resolve(true);
      });
    },
    // 获取传播者头像和名字信息
    getImageByOpenid() {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(that.options.apiurl, {
            action: "/sales/pageselfconfig/getImageByOpenid",
            requestParam: {
              obj: {
                refereeopenid: that.options.refereeopenid
              }
            }
          })
          .then(data => {
            resolve(data);
          });
      });
    },
    // 获取自行动配置
    getHDKPageSelfConfig() {
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(that.options.apiurl, {
            action: "/sales/pageselfconfig/getHDKPageSelfConfig",
            requestParam: {
              obj: {
                pageid: that.options.pageid
              }
            }
          })
          .then(function(data) {
            resolve(data);
          });
      });
    },
    // 获取所有信息
    getAllInfo() {
      let that = this;
      let allPromise = Promise.all([
        that.getImageByOpenid(),
        that.getHDKPageSelfConfig()
      ]).then(values => {
        console.log("getAllInfo", values);
        if (values[0] && values[0].code == 0) {
          that.spreadInfo = values[0].obj;
        }
        if (
          values[1] &&
          values[1].code === 0 &&
          values[1].obj &&
          typeof values[1].obj === "object"
        ) {
          that.createPageSelfConfigPop(values[1].obj).then(function() {
            if (that.options.type == 0) {
              // 自行动首次弹出
              that.promptSound.play();
              that.showSelfAction();
            } else if (that.options.type == 1) {
              // 显示浮悬球主动点击
              that.showBall();
            }
          });
        }
      });
    }
  },
  created() {},
  mounted() {
    let that = this;
    util.checkMapStateCallback(that, ["hdkUserInfo", "cardInfo"]).then(() => {
      // 如果自己打开自己传播的内容就不要自行动了
      if (global_.isLoc || false) {
        // 本地要测试，放开了
        that.getAllInfo();
      } else if (
        that.cardInfo.User &&
        that.cardInfo.User.Id &&
        that.hdkUserInfo.User &&
        that.hdkUserInfo.User.Id &&
        that.cardInfo.User.Id == that.hdkUserInfo.User.Id
      ) {
      } else {
        that.getAllInfo();
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 20;
}

.popup-layer {
  position: absolute;
  left: 25px;
  right: 25px;
  top: 11%;
  background: transparent;
}

.popup-layer .popup {
  width: 100%;
  // background: url(https://assets.rurushishi.com/yq-rs-make/components/mask/new-bg.png);
  background: #fff;
  background-size: 100% 100%;
  position: relative;
  border-radius: 0.2rem;
}

.popup .top-layer {
  display: box;
  display: -webkit-box;
  box-orient: horizontal;
  -webkit-box-orient: horizontal;
  box-pack: center;
  -webkit-box-pack: center;
  box-align: center;
  -webkit-box-align: center;
  padding: 0.4rem 10px;
}

.popup .top-layer .headImg {
  display: block;
  width: 60px;
  min-height: 60px;
  border-radius: 60px;
  -webkit-border-radius: 60px;
}

.popup .top-layer .headImg>img {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 60px;
  -webkit-border-radius: 60px;
  animation: mySwing 3s infinite;
}

.popup .top-layer .headImg>span {
  display: block;
  width: 1.2rem;
  line-height: 0.6rem;
  text-align: center;
  overflow: hidden;
}

.popup .top-layer .title {
  box-flex: 1;
  -webkit-box-flex: 1;
  font-size: 16px;
  color: #694524;
  margin-left: 0.1rem;
  padding: 8px 5px;
  box-sizing: border-box;
  line-height: 30px;
  font-weight: 400;
  border: 1px solid #f46060;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  background: #f8f2f2;
}

.popup .item-layer {
  border-bottom: 1px solid #f5f5f5;
  margin-top: 10px;
}

.popup .item-layer .item {
  width: 90%;
  margin: 0 auto;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 1px solid #f5f5f5;
  color: #000;
  font-size: 16px;
  font-weight: 300;
  position: relative;
  font-family: 'Arial', 'Microsoft YaHei', '黑体', '宋体', sans-serif;
}

.popup .item-layer .wx {
  color: #fe776a !important;
}

.popup .item-layer .item:after {
  position: absolute;
  content: '';
  right: 10px;
  height: 0.24rem;
  width: 0.24rem;
  top: 50%;
  margin-top: -0.12rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/arrow.png') no-repeat center center;
  background-size: cover;
}

.popup .item-layer .phone {
  box-sizing: border-box;
  padding-left: 0.6rem;
  display: block;
}

.popup .item-layer .phone:before {
  position: absolute;
  content: '';
  left: 0rem;
  height: 0.5rem;
  width: 0.5rem;
  top: 50%;
  margin-top: -0.25rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/phone.png') no-repeat center center;
  background-size: cover;
}

.btn {
  width: 90%;
  margin: 0 auto;
  height: 1rem;
  margin-top: 0.3rem;
  // background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/btn.png') no-repeat center center;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/self-action/chat.png') no-repeat center center;
  background-size: cover;
}

.close {
  width: 0.88rem;
  height: 0.88rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/close2.png') no-repeat center center;
  background-size: 0.64rem 0.64rem;
  z-index: 99999;
  margin: 0 auto;
  margin-top: 0.5rem;
}

.fload-head {
  position: fixed;
  z-index: 20;
  top: 15%;
  right: 10px;
}

.fload-head > img {
  display: block;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  -webkit-border-radius: 45px;
  border: 4px solid #f46060;
  animation: mySwing 5s infinite;
  -webkit-animation: mySwing 5s infinite;
}

.info-layer {
  position: absolute;
  width: 212px;
  top: 310px;
  left: 50%;
  margin-left: -106px;
}

.info-layer > img {
  width: 44px;
  border-radius: 44px;
  -webkit-border-radius: 44px;
  border: 2px solid #f6cd3f;
  margin: 0 auto;
  display: block;
}

.box-layer {
  width: 212px;
  height: 88px;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/share2.png') no-repeat center center;
  background-size: 100% 100%;
  margin-top: -22px;
  text-align: center;
  color: #f6cd3f;
  font-size: 16px;
  line-height: 80px;
}
</style>


